import {MithrilComponent} from '@bitstillery/mithril'
import {FieldSelect} from '@bitstillery/common/components/fields/select/select'
import m from '@bitstillery/mithril'

import type {FieldSelectAttrs} from '@bitstillery/common/types/field'

// Hardcoded list; reconsider when Portal & Discover can use a common endpoint.
const CURRENCY_OPTIONS = ['EUR', 'USD', 'GBP', 'JPY']

/** FieldCurrency provides options internally; callers need not pass options */
export type FieldCurrencyAttrs = Omit<FieldSelectAttrs, 'options'>

export class FieldCurrency extends MithrilComponent<FieldCurrencyAttrs> {
    view(vnode: m.Vnode<FieldCurrencyAttrs>): m.Children {
        return (
            <FieldSelect
                className='c-field-composed-currency'
                options={CURRENCY_OPTIONS.map((currency) => ({label: currency, value: currency}))}
                {...vnode.attrs}
            />
        )
    }
}
